var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { InputRule } from "prosemirror-inputrules";
import Node from "./Node";
var HorizontalRule = /** @class */ (function (_super) {
    __extends(HorizontalRule, _super);
    function HorizontalRule() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(HorizontalRule.prototype, "name", {
        get: function () {
            return "hr";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HorizontalRule.prototype, "schema", {
        get: function () {
            return {
                group: "block",
                parseDOM: [{ tag: "hr" }],
                toDOM: function () {
                    return ["hr"];
                },
            };
        },
        enumerable: true,
        configurable: true
    });
    HorizontalRule.prototype.commands = function (_a) {
        var type = _a.type;
        return function () { return function (state, dispatch) {
            dispatch(state.tr.replaceSelectionWith(type.create()).scrollIntoView());
            return true;
        }; };
    };
    HorizontalRule.prototype.keys = function (_a) {
        var type = _a.type;
        return {
            "Mod-_": function (state, dispatch) {
                dispatch(state.tr.replaceSelectionWith(type.create()).scrollIntoView());
                return true;
            },
        };
    };
    HorizontalRule.prototype.inputRules = function (_a) {
        var type = _a.type;
        return [
            new InputRule(/^(?:---|___\s|\*\*\*\s)$/, function (state, match, start, end) {
                var tr = state.tr;
                if (match[0]) {
                    tr.replaceWith(start - 1, end, type.create({}));
                }
                return tr;
            }),
        ];
    };
    HorizontalRule.prototype.toMarkdown = function (state, node) {
        state.write(node.attrs.markup || "\n---");
        state.closeBlock(node);
    };
    HorizontalRule.prototype.parseMarkdown = function () {
        return { node: "hr" };
    };
    return HorizontalRule;
}(Node));
export default HorizontalRule;
